<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{PageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Discount Type-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="WellnessTitle">Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="WellnessTitle" type="text" class="form-control" id="WellnessTitle" placeholder="Title">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.WellnessTitle}}</font>
                                </div>
                            </div>
                            <!--Title-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="title">Title Second Line :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="title" type="text" class="form-control" id="title" placeholder="Title Second Line">
                                    <font class="text-danger">{{frontendErrors.title}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="tag_line">Tag Line :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="tag_line" type="text" class="form-control" id="tag_line" placeholder="Tag Line">
                                    <font class="text-danger">{{frontendErrors.title}}</font>
                                </div>
                            </div>
                            <!--Status-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="status">Status :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="status"
                                              name="status"
                                              @input="changedValueStatus()"
                                              id="status"
                                              label="text"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="statusArr"
                                              placeholder="Select Status">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.status}}</font>
                                </div>
                            </div>
                            <!--Image-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Wellness Image :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger"> {{frontendErrors.fileUpload}}<strong id="uploadErrorMsg" class="error text-danger"></strong></font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="imageLink">Link for Wellness Image :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="imageLink" type="text" class="form-control" id="imageLink" placeholder="Image Link">
                                    <font class="text-danger">{{frontendErrors.imageLink}}</font>
                                </div>
                            </div>
                            <!--Image-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Wellness Flyer :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop2"
                                        :options="dropzoneFlyerOptions"
                                        ref="dropzone_flyer"
                                        :destroyDropzone="false"
                                        :headers="dropzoneFlyerOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFlyer"
                                        @vdropzone-success="vfileSuccessFlyer"
                                        @vdropzone-total-upload-progress="progressOfUloadFlyer"
                                        name="flyer"
                                        >
                                    </vue-dropzone>
                                    <font class="text-danger"> {{frontendErrors.flyerUpload}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="websiteLink">Website Link :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="websiteLink" type="text" class="form-control" id="websiteLink" placeholder="Website Link">
                                    <font class="text-danger">{{frontendErrors.websiteLink}}</font>
                                </div>
                            </div>
                            <!--Location-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              multiple
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.locationId}}</font>
                                </div>
                            </div>
                            <!--Role ID-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Wellness For :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="roleId"
                                              @change="changedValue"
                                              @input="changedValueSearchFor()"
                                              name="roleId"
                                              id="roleData"
                                              label="text"
                                              :filterable="false"
                                              :options="roleArr"
                                              @search="onSearchRole"
                                              placeholder="Select Wellness For">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.roleId}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="descriptionTitle">Description Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="descriptionTitle" type="text" class="form-control" id="descriptionTitle" placeholder="Description Title">
                                </div>
                            </div>
                            <!--Description-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea class="form-control" id="description" v-model="description" name="description" placeholder="Write Some Description"></textarea>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addWellnessBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addWellness()">
                                    <input id="addAndContinueWellnessBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addWellness(flag='Save and Continue')">
                                    <input id="CancelWellness" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from 'vue';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    var myDate = new Date();

    export default {
        name: 'AddDiscount',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                PageTitle: 'Add Wellness',
                WellnessTitle: '',
                phoneNo: '',
                tag_line: '',
                email: '',
                imageSize: '',
                flyerSize: '',
                websiteLink: '',
                imageLink: '',
                descriptionTitle: '',
                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpg, .jpeg, .png, .JPG, .JPEG, .PNG",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "Image is to big ({{filesize}}mb). Max allowed image size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid Image Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 image is allowed",
                    dictDefaultMessage: "Drop image here to upload",
                },
                dropzoneFlyerOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".pdf, .PDF",
                    // previewTemplate: '<div class="dz-preview dz-complete dz-image-preview"><div class="dz-image"><img data-dz-thumbnail src="/static/images/pdf-icon.png" style="width: 150px; height: 150px; object-fit: contain;"></div></div>',
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop file here to upload",
                },
                imageURL: '',
                flyerURL: '',
                isDropFileUploaded: false,
                isDropFlyerUploaded: false,
                filePath: '',
                flyerPath: '',

                //V-model
                isFileUploaded: false,
                fileUploaded: true,
                fileUploadedFlyer: true,
                isFlyerUploaded: false,
                title: '',
                description: '',
                duration: '',
                locationId: '',
                locationArr: [],

                roleId: '',
                roleArr: [],
                status: {value: 'active', text: 'Active'},
                statusArr: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'}
                ],

                //Errors
                frontendErrors: {
                    WellnessTitle: '',
                    title: '',
                    fileUpload: '',
                    flyerUpload: '',
                    locationId: '',
                    roleId: '',
                    status: '',
                    websiteLink: '',
                    imageLink: '',
                },
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.loadLocationsAdd();
            self.loadRoleFirst();
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatewellness') {
                if (segments[3]) {
                    self.PageTitle = "Update Wellness";
                    self.loadWellness();
                    $("#addAndContinueWellnessBtn").hide();
                    $("#addWellnessBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit Video");
                }
            }
            $("#websiteLink").on('keyup', function () {
                self.frontendErrors.websiteLink = '';
            });
            $("#imageLink").on('keyup', function () {
                self.frontendErrors.imageLink = '';
            });
            $("#WellnessTitle").on('keyup', function () {
                self.frontendErrors.WellnessTitle = '';
            });
            $("#title").on('keyup', function () {
                self.frontendErrors.title = '';
            });
            $("#locationId").on('keyup', function () {
                self.frontendErrors.locationId = '';
            });
            $("#roleId").on('keyup', function () {
                self.frontendErrors.roleId = '';
            });

            $("#alertError").hide();
        },
        /*watch: {
         filePath: function (filePath) {
         console.log("filePath : "+filePath);
         },
         flyerPath: function (flyerPath) {
         console.log("flyerPath : "+flyerPath);
         }
         },*/
        methods: {
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
            },
            removeAllFilesFlyer() {
                self.$refs.dropzone_flyer.removeAllFiles();
            },
            uploadManually(file) {
                if (self.filePath != '') {
                    var file_name = self.getFileName(self.filePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.filePath;
                    let file_size = self.imageSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /* self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },
            uploadManuallyFlyer(file) {
                if (self.flyerPath != '') {
                    var file_name = self.getFileName(self.flyerPath);
                    let file_type = self.getFileType(file_name);
                    let url = self.flyerPath;
                    let file_size = self.flyerSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone_flyer.manuallyAddFile(file_data, url);
                    // if (file_data.type == 'image/pdf') {
                    //     file_data.previewElement.querySelector('.dz-image img').src = '/static/images/pdf-icon.png';
                    // }
                    /* self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },
            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                if(file_type.includes('pdf') || file_type.includes('PDF')){
                    return 'application/' + file_type;
                }
                return 'image/' + file_type;
            },
            checkForm: function () {
                var checked = true;
                self.frontendErrors.WellnessTitle = '';
                if (!self.WellnessTitle) {
                    self.frontendErrors.WellnessTitle = "Title is required";
                    if (checked) {
                        checked = false;
                    }
                }
                /*if (!self.title) {
                 self.frontendErrors.title = "Title Second Line is required";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                if (self.websiteLink != '' && (!self.validUrl(self.websiteLink) || !self.validUrlHttp(self.websiteLink))) {
                    self.frontendErrors.websiteLink = 'Please enter valid URL';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.imageLink != '' && (!self.validUrl(self.imageLink) || !self.validUrlHttp(self.websiteLink))) {
                    self.frontendErrors.imageLink = 'Please enter valid URL';
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.locationId = "";
                if (self.locationId.length === 0) {
                    self.frontendErrors.locationId = "State is required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.roleId = "";
                if (!self.roleId) {
                    self.frontendErrors.roleId = "Wellness For is required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.status = "";
                if (!self.status) {
                    self.frontendErrors.status = "Status is required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.fileUpload = "";
                if (self.isFileUploaded == false) {
                    self.frontendErrors.fileUpload = "Wellness Image is required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploaded == false) {
                    self.frontendErrors.fileUpload = "Please Wait While Image Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploadedFlyer == false) {
                    self.frontendErrors.flyerUpload  = "Please Wait While Flyer Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },
            validUrlHttp: function (url) {
                var tarea = url;
                if (tarea.indexOf("http://") == 0 || tarea.indexOf("https://") == 0) {
                    return true;
                } else {
                    return false;
                }
            },
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listwellness');
            },
            removedSelectedFile(file, xhr, error) {
                console.log("Image");
                var filePath = JSON.parse(file.xhr.response);
                self.imageURL = '';
                self.isDropFileUploaded = false;
                self.isFileUploaded = false;
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
            },
            removedSelectedFlyer(file, xhr, error) {
                console.log("Flyer");
                var filePath = JSON.parse(file.xhr.response);
                self.flyerURL = '';
                self.isDropFlyerUploaded = false;
                self.isFlyerUploaded = false;
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfileSuccess: function (file, response) {
                if (self.isDropFileUploaded == false) {
                    self.imageURL = file.dataURL;
                    self.isDropFileUploaded = true;
                    self.isFileUploaded = true;
                    self.frontendErrors.fileUpload = '';
                    var filePathJSON = JSON.parse(file.xhr.response);
                    self.filePath = filePathJSON.content.media_path;
                    self.imageSize = file.size;
                } else if (self.isDropFileUploaded == true) {
                    self.removedSelectedFile(file);
                    var err = "You can Upload Only One Image";
                    $("#uploadErrorMsg").html(err);
                }
            },
            vfileSuccessFlyer: function (file, response) {
                if (self.isDropFlyerUploaded == false) {
                    self.flyerURL = file.dataURL;
                    self.isDropFlyerUploaded = true;
                    self.isFlyerUploaded = true;
                    self.frontendErrors.flyerUpload = '';
                    var filePathJSON = JSON.parse(file.xhr.response);
                    self.flyerPath = filePathJSON.content.media_path;
                    self.flyerSize = file.size;
                } else if (self.isDropFlyerUploaded == true) {
                    self.removedSelectedFile(file);
                    var err = "You can Upload Only One File";
                    $("#uploadErrorMsg").html(err);
                }
            },
            changeStartDt: function () {
                self.frontendErrors.startDate = "";
                self.optionsEnd.minDate = self.startDate;
                //console.log('mindate 2 ' + self.optionsEnd.minDate+"dsfsd");
            },
            changeEndDt: function () {
                self.frontendErrors.endDate = "";
                self.optionsStart.maxDate = self.endDate;
                //console.log('maxdate 2 ' + self.optionsStart.maxDate +"fad");
            },
            changedValue: function (value) {
                //console.log(value);
            },
            onSearchRole(search, loading) {
                if (search.length >= 1) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadRole(loading, search, this);
                }
            },
            changedValueSearchFor: function () {
                self.frontendErrors.roleId = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            changedValueLocation: function () {
                self.frontendErrors.locationId = '';
            },
            changedValueStatus: function () {
                self.frontendErrors.status = '';
            },
            loadRole(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    search: search
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            self.roleArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            /*console.log(err);*/
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadRoleFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    /*search: ''*/
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            self.roleArr = response.data.content;
                        })
                        .catch(function (err) {
                            /*console.log(err);*/
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                /*self.error = response.data.message;*/
                            }
                        });
            },

            loadWellness() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: segments[3],
                    }
                };
                self.showLoader();
                HTTP.get("getwellness", config)
                        .then(function (response) {
                            // self.locationId = {
                            //     value: response.data.content.location_id,
                            //     text: response.data.content.location_name,
                            // };
                            self.locationId = [];
                            for (var i = 0; i < response.data.content.location.length; i++) {
                                self.locationId.push({'text': response.data.content.location[i].name, 'value': response.data.content.location[i].id});
                            }
                            ;
                            self.status = {
                                value: response.data.content.status,
                                text: self.formatString(response.data.content.status),
                            };
                            self.roleId = {
                                value: response.data.content.role_id,
                                text: response.data.content.role_name,
                            };
                            self.WellnessTitle = response.data.content.title;
                            self.title = response.data.content.second_title;
                            self.tag_line = response.data.content.tag_line;

                            self.flyerPath = response.data.content.flyer;
                            if (self.flyerPath != '') {
                                self.isFlyerUploaded = true;
                                self.flyerSize = response.data.content.flyer_size;
                                self.uploadManuallyFlyer();
                            }
                            self.websiteLink = response.data.content.website_link;
                            self.filePath = response.data.content.image;
                            if (self.filePath != '') {
                                self.isFileUploaded = true;
                                self.imageSize = response.data.content.image_size;
                                self.uploadManually();
                            }
                            self.imageLink = response.data.content.image_link;
                            self.descriptionTitle = response.data.content.description_title;
                            self.description = response.data.content.description;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            console.log(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            addWellness(flag) {
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");
                    if (segments[2] == 'updatewellness') {
                        if (segments[3]) {
                            var data = {
                                id: segments[3],
                                wellness_title: self.WellnessTitle,
                                title: self.title,
                                tag_line: self.tag_line,
                                status: self.status.value,
                                image_path: self.filePath,
                                image_size: self.imageSize,
                                flyer_path: self.flyerPath,
                                flyer_size: self.flyerSize,
                                image_link: self.imageLink,
                                website_link: self.websiteLink,
                                location_id: locationsId,
                                role_id: self.roleId.value,
                                description_title: self.descriptionTitle,
                                description: self.description,
                            };
                            $("#addWellnessBtn").val("Updating ...");
                            $("#addWellnessBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelWellness").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueWellnessBtn").val("Saving ...");
                                $("#addAndContinueWellnessBtn").prop("disabled", true);
                                $("#addWellnessBtn").prop("disabled", true);
                                $("#CancelWellness").prop("disabled", true);
                            } else {
                                $("#addWellnessBtn").val("Saving ...");
                                $("#addWellnessBtn").prop("disabled", true);
                                $("#addAndContinueWellnessBtn").prop("disabled", true);
                                $("#CancelWellness").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            wellness_title: self.WellnessTitle,
                            title: self.title,
                            tag_line: self.tag_line,
                            status: self.status.value,
                            image_path: self.filePath,
                            image_size: self.imageSize,
                            flyer_path: self.flyerPath,
                            flyer_size: self.flyerSize,
                            image_link: self.imageLink,
                            website_link: self.websiteLink,
                            location_id: locationsId,
                            role_id: self.roleId.value,
                            description_title: self.descriptionTitle,
                            description: self.description,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueWellnessBtn").val("Saving ...");
                            $("#addAndContinueWellnessBtn").prop("disabled", true);
                            $("#addWellnessBtn").prop("disabled", true);
                            $("#CancelWellness").prop("disabled", true);
                        } else {
                            $("#addWellnessBtn").val("Saving ...");
                            $("#addWellnessBtn").prop("disabled", true);
                            $("#addAndContinueWellnessBtn").prop("disabled", true);
                            $("#CancelWellness").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("savewellness", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                self.removeAllFilesFlyer();
                                if (segments[2] == 'updatewellness') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addWellnessBtn").val("Update");
                                        $("#addWellnessBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelWellness").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueWellnessBtn").val("Save and Continue");
                                            $("#addAndContinueWellnessBtn").prop("disabled", false);
                                            $("#addWellnessBtn").prop("disabled", false);
                                            $("#CancelWellness").prop("disabled", false);
                                        } else {
                                            $("#addWellnessBtn").val("Save");
                                            $("#addWellnessBtn").prop("disabled", false);
                                            $("#addAndContinueWellnessBtn").prop("disabled", false);
                                            $("#CancelWellness").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueWellnessBtn").val("Save and Continue");
                                        $("#addAndContinueWellnessBtn").prop("disabled", false);
                                        $("#addWellnessBtn").prop("disabled", false);
                                        $("#CancelWellness").prop("disabled", false);
                                    } else {
                                        $("#addWellnessBtn").val("Save");
                                        $("#addWellnessBtn").prop("disabled", false);
                                        $("#addAndContinueWellnessBtn").prop("disabled", false);
                                        $("#CancelWellness").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");

                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.WellnessTitle = '';
                                        self.title = '';
                                        self.tag_line = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.filePath = '';
                                        self.imageSize = 0;
                                        self.flyerPath = '';
                                        self.flyerSize = 0;
                                        self.imageLink = '';
                                        self.websiteLink = '';
                                        self.locationId = '';
                                        self.roleId = '';
                                        self.descriptionTitle = '';
                                        self.description = '';
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();

                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                self.removeAllFilesFlyer();
                                if (segments[2] == 'updatewellness') {
                                    if (segments[3]) {
                                        $("#addWellnessBtn").val("Update");
                                        $("#addWellnessBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelWellness").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueWellnessBtn").prop("disabled", false);
                                            $("#addAndContinueWellnessBtn").val("Save and Continue");
                                            $("#addWellnessBtn").prop("disabled", false);
                                            $("#CancelWellness").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.WellnessTitle = '';
                                            self.title = '';
                                            self.tag_line = '';
                                            self.status = {value: 'active', text: 'Active'};
                                            self.filePath = '';
                                            self.imageSize = 0;
                                            self.flyerPath = '';
                                            self.flyerSize = 0;
                                            self.imageLink = '';
                                            self.websiteLink = '';
                                            self.locationId = '';
                                            self.roleId = '';
                                            self.descriptionTitle = '';
                                            self.description = '';
                                            /*$("#status option[value='']").attr('selected', true);
                                             $("#type option[value='']").attr('selected', true);*/

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addWellnessBtn").val("Save");
                                            $("#addWellnessBtn").prop("disabled", false);
                                            $("#addAndContinueWellnessBtn").prop("disabled", true);
                                            $("#CancelWellness").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueWellnessBtn").prop("disabled", false);
                                        $("#addAndContinueWellnessBtn").val("Save and Continue");
                                        $("#addWellnessBtn").prop("disabled", false);
                                        $("#CancelWellness").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.WellnessTitle = '';
                                        self.title = '';
                                        self.tag_line = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.filePath = '';
                                        self.imageSize = 0;
                                        self.flyerPath = '';
                                        self.flyerSize = 0;
                                        self.imageLink = '';
                                        self.websiteLink = '';
                                        self.locationId = '';
                                        self.roleId = '';
                                        self.descriptionTitle = '';
                                        self.description = '';
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addWellnessBtn").val("Save");
                                        $("#addWellnessBtn").prop("disabled", false);
                                        $("#addAndContinueWellnessBtn").prop("disabled", true);
                                        $("#CancelWellness").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.frontendErrors.fileUpload = "";
                } else {
                    self.fileUploaded = false;
                }
            },
            progressOfUloadFlyer(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploadedFlyer = true;
                    self.frontendErrors.flyerUpload = "";
                } else {
                    self.fileUploadedFlyer = false;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/wellness/AddWellness.vue